// import $ from 'jquery'

export default class {
  constructor (selector) {
    $(selector || '[data-role="slider"]').each((index, element) => {
      $(element).slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1200,
        arrows: false,
        dots: true,
        draggable: false,
        touchMove: false,
        fade: false,
        pauseOnHover: false,
        infinite: true,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev"><i class="fas fa-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="fas fa-chevron-right"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: false
            }
          }
        ]
      })
    })
  }
}
